import { useMutation, useQuery } from "@tanstack/react-query";
import { useFormik } from "formik";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import * as yup from "yup";
import DropDown from "../../components/DropDown";
import NavigateBack from "../../components/NavigateBack";
import useSlider from "../../hooks/useSlider";
import {
  addDataList,
  getAllCompany,
  getCompanyLocation,
  getDataListbyId,
  getItems,
  updateDataList,
} from "../../services/services";
import { constant } from "../../utils/constants";
import Sidebar from "../sidebar/Sidebar";
import i18next from "i18next";
import { toastAlert } from "../../utils/SweetAlert";

const AddnewPreplist = () => {
  const [searchParam] = useSearchParams();
  const id = searchParam.get("id");
  const { t } = useTranslation();
  const isSlider = useSlider();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    values,
    handleBlur,
    handleChange,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    setValues,
    setFieldTouched,
  } = useFormik({
    initialValues: {
      company: "",
      productionName: "",
      items: "",
      qtyLabel: "",
      labelProfile: "",
      // prepQty: "",
      locations: [],
      assignAll: false,
    },
    validationSchema: yup.object().shape({
      company: yup.object().shape({
        value: yup.string().required().label(t("product.company")),
      }),
      productionName: yup
        .string()
        .required()
        .label(t("prepList.productionName")),
      items: yup.object().shape({
        value: yup.string().required().label(t("prepList.items")),
      }),
      qtyLabel: yup
        .number()
        .required()
        .typeError(t("errorMsg.invalidNumber"))
        .positive()
        .min(1)
        .label(t("prepList.qunatityLabel")),
    }),
    onSubmit: (values) => {
      let body = {
        name: values?.productionName,
        type: constant.DATA_LIST.PREP_LIST,
        itemId: values?.items?.value,
        assignAll: values?.assignAll,
        details: {
          labelQuantity: values?.qtyLabel,
          prepQuantity: values?.prepQty,
          labelProfile: values?.labelProfile,
        },
      };
      if (!values?.assignAll) {
        body.locations = values?.locations;
      }
      mutation.mutate(body);
    },
  });

  const mutation = useMutation({
    mutationFn: (body) =>
      !!id
        ? updateDataList(id, body, values?.company?.domain)
        : addDataList(body, values?.company?.domain),
    onSuccess: (resp) => {
      toastAlert("success", resp?.data?.message);
      navigate("../prep-list", {
        state: location?.state ? location?.state : values?.company,
      });
    },
  });

  useQuery({
    queryKey: ["receiving-details", id],
    queryFn: async () => {
      const resp =
        !!location?.state?.domain &&
        !!id &&
        (await getDataListbyId(id, location?.state?.domain,true));
      let data = resp?.data?.data;
// console.log('data :>> ', data);
      if (data) {
        setValues({
          ...values,
          company: location?.state,
          productionName: data?.name,
          items: {
            value: data?.itemDetails?._id,
            label: data?.itemDetails?.en_name,
            locations: data?.itemDetails?.locations,
            assignAll: data?.itemDetails?.assignAll,
          },
          qtyLabel: data?.details?.labelQuantity,
          labelProfile: data?.details?.labelProfile,
          // prepQty: data?.details?.prepQuantity,
          // locations: data?.locations,
 locations: resp?.data?.data?.locations?.map((i) => ({
            label: i?.name,
            value: i?._id,
          })),
          assignAll: data?.assignAll,
        });
      }
      return true;
    },
  });

  const loadCompany = async (search, loadedOptions, { page }) => {
    let resp = await getAllCompany(page, constant.PER_PAGE_TEN, search);
    let array = (await resp?.data?.data?.companies) ?? [];
    return {
      options: array.map((item) => ({
        value: item?._id,
        label: item?.name,
        domain: item?.uuid,
      })),
      hasMore: loadedOptions.length == resp?.data?.data?.total ? false : true,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadLocations = async (search, loadedOptions, { page }) => {
    let resp =
      values?.company?.domain &&
      (await getCompanyLocation(
        values?.company?.domain,
        page,
        constant.PER_PAGE_TEN,
        search,

      ));

    let array = (await resp?.data?.data?.locations?.locations) ?? [];

    return {
      options: array.map((item) => ({
        value: item?._id,
        label: item?.name,
      })),
      hasMore:
        loadedOptions.length == resp?.data?.data?.locations?.total
          ? false
          : true,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadItems = async (search, loadedOptions, { page }) => {
    let resp =
      values?.company?.domain &&
      (await getItems(
        page,
        constant.PER_PAGE_TEN,
        values?.company?.domain,
        false
      ));

    let array = (await resp?.data?.data?.items) ?? [];
    return {
      options: array.map((item) => ({
        value: item?._id,
        label: item?.en_name,
        locations: item?.locations,
        assignAll: item?.assignAll,
      })),
      hasMore: loadedOptions.length == resp?.data?.data?.total ? false : true,
      additional: {
        page: page + 1,
      },
    };
  };

  return (
    <div className="mainbox">
      <Sidebar />
      <div className={isSlider ? "body-content close" : "body-content open"}>
        <Row>
          <Col xl={12}>
            <NavigateBack path={"../prep-list"} state={location?.state}>
              {!!id ? t("prepList.editPrepList") : t("prepList.addNewPrepList")}
            </NavigateBack>
          </Col>
        </Row>
        <div className="basic_Info">
          <Row>
            <Col md={12}>
              <div className="w-100">
                <label htmlFor="name" className="fontSize16 mb-2">
                  {t("user.company")} <span className="text-danger">*</span>
                </label>
                <DropDown
                  placeholder={t("user.selectCompany")}
                  id="company"
                  loadOptions={loadCompany}
                  isClearable={false}
                  isDisabled={!!id}
                  onChange={(e) => {
                    setFieldValue("company", e);
                    setFieldValue("locations", []);
                  }}
                  value={values?.company}
                  onBlur={() => setFieldTouched("company", true)}
                />
                <small className="text-danger ms-1">
                  {touched?.company && errors?.company?.value}
                </small>
              </div>
            </Col>
            <Col md={6}>
              <div className="mt-2">
                <label htmlFor="productionName" className="companyLabel">
                  {t("prepList.productionName")}{" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="productionName"
                  value={values?.productionName}
                  name="productionName"
                  className="commonInput"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("prepList.enterProductionName")}
                />
                <small className="text-danger ms-1">
                  {touched?.productionName && errors?.productionName}
                </small>
              </div>
            </Col>
            <Col md={6}>
              <div className="mt-2">
                <label htmlFor="items" className="companyLabel">
                  {t("prepList.items")} <span className="text-danger">*</span>
                </label>
                <DropDown
                  placeholder={t("prepList.enterItem")}
                  id="items"
                  loadOptions={loadItems}
                  isClearable={false}
                  depends={values?.company?.domain}
                  value={values?.items}
                  onChange={(e) => {
                    setFieldValue("items", e);
                    setFieldValue("locations", e?.locations);
                    setFieldValue("assignAll", e?.assignAll);
                  }}
                  onBlur={() => setFieldTouched("items", true)}
                />
                <small className="text-danger ms-1">
                  {touched?.items && errors?.items?.value}
                </small>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="mt-3">
                <label htmlFor="qtyLabel" className="companyLabel">
                  {t("prepList.qunatityLabel")}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="qtyLabel"
                  value={values?.qtyLabel}
                  name="qtyLabel"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="commonInput"
                  placeholder={t("prepList.enterQtyLabel")}
                />
                <small className="text-danger ms-1">
                  {touched?.qtyLabel && errors?.qtyLabel}
                </small>
              </div>
            </Col>
            <Col md={6}>
              <div className="mt-3">
                <label htmlFor="labelProfile" className="companyLabel">
                  {t("prepList.labelProfile")}{" "}
                  {/* <span className="text-danger">*</span> */}
                </label>
                <input
                  type="text"
                  id="labelProfile"
                  name="labelProfile"
                  value={values?.labelProfile}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="commonInput"
                  placeholder={t("prepList.enterLabelProfile")}
                />{" "}
                <small className="text-danger ms-1">
                  {touched?.labelProfile && errors?.labelProfile}
                </small>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="mt-3">
                <label htmlFor="locations" className="companyLabel">
                  {t("prepList.prepLocation")}{" "}
                  <span className="text-danger">*</span>
                </label>
                <DropDown
                  placeholder={t("prepList.enterPrepLocaiton")}
                  id="locations"
                  loadOptions={loadLocations}
                  isClearable={false}
                  depends={values?.company?.value}
                  isMulti={true}
                  value={values?.locations}
                  onChange={(e) => setFieldValue("locations", e)}
                  onBlur={() => setFieldTouched("locations", true)}
                />
                <small className="text-danger ms-1">
                  {touched?.locations && errors?.locations}
                </small>
              </div>
            </Col>
            <Col md={6}>
              <div className="customer_Access">
                <div className="access_Child">
                  <div className="form-group">
                    <input
                      type="checkbox"
                      id="assignAll"
                      name="assignAll"
                      value={values?.assignAll}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      checked={values?.assignAll == true}
                    />
                    <label htmlFor="assignAll">
                      <span className="fontSize14 ms-2">
                        {t("prepList.applyToAllCurrentAndFutreLocations")}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </Col>

            <Row>
              <Col className="mt-4" xl={12}>
                <button
                  className="userBtn btn-theme m-0"
                  type="button"
                  onClick={handleSubmit}
                >
                  {!!id ? t("globals.saveChanges") : t("globals.add")}
                </button>
              </Col>
            </Row>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default AddnewPreplist;
